import type { USP } from '@bulknutrients/bulk-shared-lib/interfaces/Sanity';

import { CustomImage } from '@components/Media/Image';
import type { ReactElement } from 'react';

export function USPComponent({ usps }: { usps: USP[] }): ReactElement {
  return (
    <div
      className="flex justify-between gap-2 max-w-3xl mx-auto"
      aria-label="Product Features"
    >
      {usps.map((usp, i) => {
        const invertInDarkMode =
          !usp.text.toLowerCase().includes('hasta') &&
          !usp.text.toLowerCase().includes('vegan');

        return (
          <div
            key={`usp-${i}`}
            className={`flex-1 flex-col items-center ${i === 3 ? 'hidden sm:flex' : 'flex'}`}
          >
            <CustomImage
              image={usp.image}
              alt={usp.altText}
              width={80}
              usePlaceholder={false}
              className={invertInDarkMode ? 'dark:invert' : ''}
            />
            <span className="text-center text-xs font-bold uppercase">
              {usp.text}
            </span>
          </div>
        );
      })}
    </div>
  );
}
